<template>
    <div>
        <ModalComponent
            :name="'anular-' + base.id"
            :title="'Anular deportista: ' + base.nombre"
            @close="close"
        >
            <!-- Body -->
            <div class="tw:flex tw:flex-col tw:gap-4">
                <p class="tw:text-base tw:text-gray-700">
                    ¿Está seguro de anular este deportista?
                </p>

                <div
                    v-if="base.tiene_plazos"
                    class="tw:bg-amber-50 tw:border tw:border-amber-200 tw:rounded-lg tw:p-4 tw:text-sm tw:text-amber-800"
                >
                    <i class="fas fa-exclamation-triangle tw:mr-1.5"></i>
                    Este deportista se ha inscrito mediante plazos. Seleccione si quiere anularlo
                    devolviendo el/los plazo/s pagados o sin devolverlos.
                </div>
            </div>

            <!-- Footer -->
            <template #footer>
                <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-2">
                    <Button
                        :disabled="submitting"
                        size="sm"
                        @click="anularBase(false, 0)"
                    >
                        Anular sin devolver el dinero
                    </Button>

                    <Button
                        :disabled="submitting"
                        size="sm"
                        @click="anularBase(true, 0)"
                    >
                        Anular sin GG
                    </Button>

                    <Button
                        :disabled="submitting"
                        size="sm"
                        @click="openGGPassword"
                    >
                        Anular con GG
                    </Button>

                    <span class="tw:flex-1"></span>

                    <Button variant="ghost" size="sm" :disabled="submitting" @click="close">
                        Cancelar
                    </Button>
                </div>
            </template>
        </ModalComponent>

        <PasswordGate
            :name="'anular-gg-password-' + base.id"
            title="Anular con gastos de gestión"
            message="Para anular al deportista con gastos de gestión introduce la contraseña:"
            @confirmed="anularBase(true, 1)"
        />
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import { getCurrentInstance } from 'vue';
    import store from '@/store';
    import { config } from '@/config';
    import ModalComponent from '@/modules/admin/ui/ModalComponent.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import PasswordGate from '@/modules/admin/ui/PasswordGate.vue';
    import { useToast } from '@/composables/common/useToast';

    const props = defineProps({
        base: { type: Object, required: true },
    });

    const emit = defineEmits(['actualizado', 'close']);

    const instance = getCurrentInstance();
    const toast = useToast();

    const submitting = ref(false);

    const listaId = computed(() => instance.proxy.$route.params.lista_id);

    function anularBase(devolver_dinero = false, con_gd = 0) {
        submitting.value = true;

        const params = {
            filters: { con_gd, devolver_dinero },
            base_id: props.base.id,
            lista_id: listaId.value,
        };

        store.dispatch(config.getVuexAlias('back.bases.anular'), params)
            .then(res => {
                toast.success(res.data.message);
                emit('actualizado');
            })
            .catch(error => {
                toast.error(error.response?.data?.message || 'Error al anular el deportista');
            })
            .finally(() => {
                submitting.value = false;
                close();
            });
    }

    function openGGPassword() {
        instance.proxy.$modal.show('anular-gg-password-' + props.base.id);
    }

    function close() {
        submitting.value = false;
        emit('close', 'anular-' + props.base.id);
    }
</script>
